import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { EndpointFilterDataProviderFactory } from '../factory/EndpointFilterDataProviderFactory';
import { EndpointFilterBaseDataProvider } from '../dataProvider/EndpointFilterBaseDataProvider';
import { GetEndpointsRequest, GetEndpointsResponse } from '@nirvana/shared/dtos/types/protected-entities/gz-console';

export class EndpointFilterRepository extends BaseWebComponentRepository {
  public dataProviderFactory: EndpointFilterDataProviderFactory;
  public dataProvider: EndpointFilterBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new EndpointFilterDataProviderFactory(),
    });
  }

  async getEndpoints(request: GetEndpointsRequest): Promise<GetEndpointsResponse | undefined> {
    return this.dataProvider.getEndpoints(request);
  }
}
